import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import * as React from 'react'
import { useContext, useState } from 'react'
import alerts, { Alerts4Countries } from './alerts4countries'
import routes from '../../app/routes'
import ChannelContext from '../../context/ChannelContext'
import HistoryContext from '../../context/HistoryContext'
import FormattedMessage from '../FormattedMessage/FormattedMessage'

const SOTRAGE_ALERT_COUNTRY = 'STORAGE_ALERT_COUNTRY_'

const AlertForCountry = () => {
  const channel = useContext(ChannelContext).current

  const markAsSeen = () => {
    sessionStorage.setItem(`${SOTRAGE_ALERT_COUNTRY}${channel.country}`, 'true')
  }

  const isSeen = () => {
    const seen = sessionStorage.getItem(`${SOTRAGE_ALERT_COUNTRY}${channel.country}`)
    return seen === 'true'
  }

  const history = useContext(HistoryContext)
  const [open, setOpen] = useState<boolean>(!isSeen())
  const alertForCountry = alerts[channel.country as keyof Alerts4Countries]

  if (alertForCountry === undefined || alertForCountry.active === false) {
    return null
  }

  const goToStore = () => {
    setOpen(false)
    markAsSeen()
    history.push(routes.storeLocator)
  }

  const onClose = () => {
    setOpen(false)
    markAsSeen()
  }

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      fullWidth
      sx={{
        zIndex: 10001,
      }}
    >
      <DialogTitle>
        <FormattedMessage id={alertForCountry.title} />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage id={alertForCountry.message} />
      </DialogContent>
      <DialogActions>
        <Button color="info" variant="contained" onClick={onClose}>
          <FormattedMessage id="AlertsForCountry.Close" defaultMessage="Close" />
        </Button>
        {alertForCountry.storeLocatorButton ? (
          <Button color="primary" variant="contained" onClick={goToStore}>
            <FormattedMessage id="AlertsForCountry.GoToStoreLocator" defaultMessage="Go to store locator" />
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  )
}

export default AlertForCountry
